<template>
    <div class="tab-card">
        <form class="text-left">
            <Loading v-if="inProgess"/>
            <h3 class="text-center text-danger mb-3" v-if="errorMsg">{{ errorMsg }}</h3>
            <ExistLineFunctionality :item="item"
                                    :key="item.id" @deleteFunctionality="deleteFunctionalityBackEnd"
                                    @editFunctionality="editFunctionalityBackEnd"
                                    v-for="item in itemsForPack"
            />
            <NewLineFunctionality :items="itemsForModule" @addFunctionality="addFunctionality"
                                  @deleteFunctionality="deleteFunctionality"
                                  v-if="showNewLine"/>
            <div class="px-4" v-if="showAddButton">
                <div class="row">
                    <div class="col-lg-12">
                        <a @click="addNewFunctionalityForPack" type="button">
                            <i class="fa fas fa-plus-circle functionality-add-pack"></i>
                        </a>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import NewLineFunctionality from './NewLineFunctionality';
    import {packCountryDomain} from '../models/packCountryDomain';
    import ExistLineFunctionality from './ExistLineFunctionality';
    import {
        addNewFunctionalityForPack,
        deleteExistFunctionalityForPack,
        updateExistFunctionalityForPack
    } from '../services/packCountryDomainFunctionality.service';
    import Loading from '../../common/Loading';

    export default {
        name: 'TabFunctionality',
        components: {
            Loading,
            NewLineFunctionality,
            ExistLineFunctionality
        },
        props: {
            idModule: Number,
            selectedModule: Object,
            existFunctionlities: Array,
            restFunctionlities: Array
        },
        data() {
            return {
                errorMsg: '',
                numberOfFunctionalities: [],
                showAddButton: false,
                itemsForPack: this.existFunctionlities,
                itemsForModule: this.restFunctionlities,
                formComponent: packCountryDomain(),
                actualModule: this.selectedModule,
                actualId: null,
                filterList: [],
                inProgess: true,
                showNewLine: false
            };
        },
        methods: {
            addNewFunctionalityForPack() {
                this.showNewLine = true;
                this.showAddButton = false;
            },
            deleteFunctionality() {
                this.showNewLine = false;
                this.showAddButton = true;
            },
            addFunctionality(packCountryDomainFunctionality) {
                this.itemsForPack = [];
                this.inProgess = true;
                this.showAddButton = false;
                addNewFunctionalityForPack(packCountryDomainFunctionality.functionality.id,
                    packCountryDomainFunctionality.packCountryDomain.id,
                    packCountryDomainFunctionality.value,
                    packCountryDomainFunctionality.isDisplayed
                )
                    .then(response => {
                        this.itemsForPack = response.data['pack'];
                        this.itemsForModule = response.data['module'];
                        this.showAddButton = false;
                        this.showNewLine = false;
                        if (this.itemsForModule.length > 0) {
                            this.showAddButton = true;
                            this.showNewLine = false;
                        }
                        this.inProgess = false;
                        return response;
                    });
            },
            editFunctionalityBackEnd(id, value, isDisplayed) {
                updateExistFunctionalityForPack(id, value, isDisplayed)
                    .then(response => {
                        this.itemsForPack = response.data['pack'];
                        this.itemsForModule = response.data['module'];
                        return response;
                    });
            },
            deleteFunctionalityBackEnd(id, idFunctionality, idPackCountryDomain) {
                this.itemsForPack = [];
                this.inProgess = true;
                this.showAddButton = false;
                deleteExistFunctionalityForPack(id, idFunctionality, idPackCountryDomain)
                    .then(response => {
                        this.itemsForPack = response.data['pack'];
                        this.itemsForModule = response.data['module'];
                        this.showAddButton = true;
                        this.showNewLine = false;
                        this.inProgess = false;
                        return response;
                    });
            }
        },
        watch: {
            existFunctionlities(newVal) {
                this.itemsForPack = newVal;
                this.inProgess = false;
            },
            restFunctionlities(newVal) {
                this.itemsForModule = newVal;
                this.inProgess = false;
                if (this.itemsForModule.length > 0) {
                    this.showAddButton = true;
                }
            },
            selectedModule(newVal) {
                this.actualModule = newVal;
                this.inProgess = true;
                this.showAddButton = false;
                this.showNewLine = false;
                this.itemsForPack = [];
            }
        }
    };
</script>

<style scoped>
    @import '../../../assets/style/css/share/tab.css';
    @import '../../../assets/style/css/base.css';
</style>
